import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  title: 'You currently have no active Zeller Terminals.',
  description:
    'Accept card payments, wherever you sell. Log in to Zeller Terminal to show its details here.  ',
  item1: 'Integrates with Xero and 600+ point-of-sale platforms',
  item2: 'Zero-cost EFTPOS with built-in surcharging',
  item3: 'Wi-Fi, mobile hotspot and SIM connectivity',
  ctaDescription:
    'Don’t have a Zeller Terminal yet? Purchase one using promo code {code} at checkout to get $50 off your first Zeller Terminal.',
  couponCode: 'SIGNUP50',
  ctaPrimary: 'Shop Now',
  imageAlt: 'One Zeller-branded Black terminal',
})
